module.exports = __webpack_public_path__ + "img/login-vector.fbe78b4c.svg";